import { render, staticRenderFns } from "./CriterioRadioButton.vue?vue&type=template&id=539e702c"
import script from "./CriterioRadioButton.vue?vue&type=script&lang=js"
export * from "./CriterioRadioButton.vue?vue&type=script&lang=js"
import style0 from "./CriterioRadioButton.vue?vue&type=style&index=0&id=539e702c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports